// This file was automatically generated from app.onboarding.statusHeadline.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.onboarding.statusHeadline');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.statusHeadline.wrapper = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="headlineContainer"><div class="headlineTextContainer"><span class="headline-contents"></span></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.statusHeadline.passportEmrContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="headlineText">This is a light version of Elation Health, for you to communicate with Elation physicians. <a class="headlineButton headline-trigger" data-name="learn-more">Learn more about Elation</a><a class="headlineButton headline-trigger" data-name="activate-account">Subscribe</a></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.statusHeadline.testAccountContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="headlineText">TEST ACCOUNT. Do not enter patient information.</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.statusHeadline.needEmailVerified = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="headlineText">Please verify your email address to ensure access to your Elation account. <a class="headlineButton headline-trigger" data-name="', soy.$$escapeHtml(opt_data.name), '">Re-send verification email</a></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.statusHeadline.needCredentials = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="headlineText">Authenticate your account to get access to electronic prescribing and more. <a class="headlineButton headline-trigger" href="/settings/useraccount">Go to Settings</a></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.statusHeadline.needCredentialDocumentsReview = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="headlineText">Your account authentication is pending Elation staff review.</span>');
  if (!opt_sb) return output.toString();
};
